import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle"]

  close() {
    if (this.hasToggleTarget) {
      this.toggleTarget.checked = false
    }
  }

  // Close sidebar when clicking on a link (for mobile)
  connect() {
    this.element.addEventListener("click", (event) => {
      // Close sidebar when clicking on navigation links on mobile
      if (event.target.matches("a") && window.innerWidth < 1024) {
        this.close()
      }
    })
  }
}